import { bootstrapApplication } from '@angular/platform-browser';
import { initSentry } from '@welma-education/shared/errors';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

initSentry({
  dsn: 'https://21b8dc4cca7960a8f8e91e4683300db0@o4510511486795776.ingest.de.sentry.io/4510511527886928',
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
